module.exports = __webpack_public_path__ + "img/chain13.adf4d306.png";